export const initialState = {
	items: [],
	itemsMap: {},
	subItemsMap: {}, // allows us to quickly identify scan lines/jobs/surveys using (customer, linename, and jobnumber) as keys.
	isLoading: false,
	isLoaded: false,
	errorMessage: undefined,
};

export default initialState;
